import { Node } from 'slate';
import { nanoid } from 'nanoid';

const ELEMENT_H1 = 'h1';
const ELEMENT_PARAGRAPH = 'p';

export const isJsonString = (str?: string) => {
  if (str === null) return false;

  try {
    const parsedJson = JSON.parse(str);

    if (typeof parsedJson !== 'object') {
      return false;
    }
  } catch (ex) {
    return false;
  }
  return true;
};

export const getInitialValue = (value, defaultValue = [getEmptyParagraphNode()]) => {
  let result = value;
  if (!value) {
    result = defaultValue;
  }
  if (typeof result === 'string') {
    result = JSON.parse(result);
  }
  return result;
};

export const mapEntriesToNodes = (entries: any) => {
  const objs = [];
  for (const [node] of entries) {
    objs.push(node);
  }
  return objs;
};

export const getSlateNodeText = (content, enableTrim = false) => {
  let text = '';
  const node = isJsonString(content) ? JSON.parse(content) : content;

  if (node && typeof node === 'object') {
    if (node instanceof Array) {
      try {
        text += `${node.map((n) => Node.string(n)).join(' ')}`;
      } catch (e) {
        text += '';
        console.error('Error in getSlateNodeText', e);
      }
    } else {
      text += Node.string(node);
    }
  } else {
    text += node || '';
  }
  return enableTrim ? text.trim() : text;
};

export const getSlateNodeTextWithSpecialChar = (content, enableTrim = false, specialChar) => {
  let text = '';
  const node = isJsonString(content) ? JSON.parse(content) : content;

  if (node && typeof node === 'object') {
    if (node instanceof Array) {
      text += `${node.map((n) => Node.string(n)).join(specialChar)}`;
    } else {
      text += Node.string(node);
    }
  } else {
    text += node || '';
  }
  return enableTrim ? text.trim() : text;
};
export const getSlateEditorValue = (value, defaultValue = [getEmptyParagraphNode()] as any) => {
  let result = value;
  if (!value) {
    result = defaultValue;
  }
  if (typeof result === 'string') {
    result = isJsonString(result) ? JSON.parse(result) : [getEmptyParagraphNode(result)];
  }
  return result;
};

export const getEmptyH1Node = (text = '', extraProps = {}) => {
  return {
    type: ELEMENT_H1,
    id: nanoid(),
    ...extraProps,
    children: [
      {
        text,
      },
    ],
  };
};

export const getEmptyParagraphNode = (text = '', extraProps = {}) => {
  return {
    type: ELEMENT_PARAGRAPH,
    id: nanoid(),
    ...extraProps,
    children: [
      {
        text,
      },
    ],
  };
};

export const isEmptySlateNodeValue = (content) => {
  return !getSlateNodeText(content, true);
};

export const isValidSlateNodeValue = (content) => {
  return Boolean(getSlateNodeText(content, true));
};
